import React from 'react';
import Coupon from 'gatsby-matrix-theme/src/components/atoms/coupon';
import CopyIcon from 'gatsby-matrix-theme/src/images/icons/copy-icon';
import CheckCircleIcon from 'gatsby-matrix-theme/src/images/icons/check-circle';

export default (props) => <Coupon {...props} icon={<CopyIcon color='#e00028' />} checkIcon={<CheckCircleIcon />} />;
